import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EScheduleFields = {
	notify: 'notify',
	numberOfRepetitions: 'numberOfRepetitions',
	allowToRenotify: 'allowToRenotify',
	allowToRenotifyAfterCustomValueMinutes: 'allowToRenotifyAfterCustomValueMinutes',
	allowToRenotifyAfterCustomValueHours: 'allowToRenotifyAfterCustomValueHours',
} as const;

export type TScheduleFields = TValueOfStringRecord<typeof EScheduleFields>
